export const LEAVE_ICON_NAMES = [
  "island",
  "tree",
  "tree-evergreen",
  "campfire",
  "tent",
  "virus",
  "tooth",
  "microscope",
  "flask",
  "stethoscope",
  "syringe",
  "hand-heart",
  "heartbeat",
  "baby",
  "baby-carriage",
  "armchair",
  "chair",
  "office-chair",
  "hospital",
  "mosque",
  "synagogue",
  "church",
  "cross",
  "bird",
  "toolbox",
  "suitcase-rolling",
  "suitcase",
  "handbag",
  "house",
  "buildings",
  "city",
  "building",
  "building-apartment",
  "airplane",
  "airplane-takeoff",
  "airplane-in-flight",
  "truck",
  "bus",
  "van",
  "car",
  "traffic-signal",
  "traffic-cone",
  "books",
  "medal-military",
  "medal",
  "projector-screen",
  "student",
  "graduation-cap",
  "backpack",
  "confetti",
  "balloon",
  "cake",
  "hamburger",
  "bowl-steam",
  "coffee",
  "cash-register",
  "credit-card",
  "money",
  "wallet",
];
